import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    height: '100%',
    width: '100%',
    textAlign: 'justify',
    alignItems: 'flex-start'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '25px 40px 0px',
    [Device.mobile]: {
      padding: '10px 10px 0'
    }
  },
  title: {
    marginBottom: 10,
    marginTop: 10,
    display: 'flex',
    [Device.mobile]: {
      marginTop: 20,
      width: '100%'
    }
  },
  totalDebt: {
    margin: '12px 10px',
    textAlign: 'right',
    [Device.mobile]: {
      textAlign: 'center'
    }
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '25px 40px 25px 40px',
    width: '60%',
    [Device.mobile]: {
      width: '100%',
      margin: 0,
      boxSizing: 'border-box',
      padding: '10px 10px 15px 10px'
    }
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: 20,
    [Device.mobile]: {
      paddingBottom: 20
    }
  },
  field: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 40px',
    width: '55%',
    boxSizing: 'border-box',
    background: 'transparent',
    [Device.mobile]: {
      width: '100%',
      padding: '10px 10px'
    }
  },
  continueButton: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '40px',
    [Device.mobile]: {
      justifyContent: 'center',
      margin: '40px auto'
    }
  },
  checkContainer: {
    margin: '20px 20px 20px 40px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [Device.mobile]: {
      textAlign: 'left',
      margin: 0,
      padding: '20px 10px',
      boxSizing: 'border-box'
    }
  },
  registerSelectField: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    margin: '15px 0px 25px'
  },
  formContainer: {
    paddingLeft: '40px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: 15,
    width: '65%',
    display: 'flex',
    [Device.mobile]: {
      width: '100%',
      padding: '0px 10px',
      boxSizing: 'border-box'
    }
  },
  fieldsContainer: {
    alignSelf: 'flex-start',
    marginTop: 15,
    width: '79.5%',
    [Device.mobile]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  userDebitCancel: {
    display: 'flex',
    margin: '10px 0px 10px 40px',
    [Device.mobile]: {
      margin: '10px 10px'
    }
  },
  debtDesc: {
    display: 'flex',
    margin: '10px 0px 10px 40px',
    [Device.mobile]: {
      margin: '10px 10px'
    }
  },
  warranties: {
    marginTop: 10
  },
  holderChangeContainer: {
    height: '100%',
    width: '100%'
  },
  helpText: {
    marginTop: 20
  },
  successMesage: {
    padding: '20px 20px 0px 20px'
  }
};
